import { makeStyles, Theme } from '@material-ui/core'

export const useSanctionStyle = makeStyles((theme: Theme) => ({
  sanctionContainer: {
    minHeight: 600,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(sectionImage.png)',
    backgroundSize: '100% 60%',
    backgroundRepeat: 'no-repeat',
    padding: 20
  },
  carusel: {
    display: 'grid',
    gridTemplateColumns: '20px 1fr',
    gridTemplateRows: '1fr',
    alignItems: 'center',
    '& .CarouselItem': {
      gridColumn: 2,
      gridRow: 1,
      padding: '0px 50px',
      margin: '0px auto',
      [theme.breakpoints.down(1024)]: {
        margin: '0px'
      }
    }
  },
  indicators: {
    gridColumn: 1,
    gridRow: 1
  },
  indicatorColor: {
    color: 'rgba(255, 255, 255, 0.6)'
  },
  activeIndicator: {
    color: `${theme.palette.success.main} !important`
  }
}))

const imageContainer = {
  gridColumn: 1,
  gridRow: 1,
  width: 210,
  height: 130,
  borderRadius: 5
}

export const useCardStyle = makeStyles((theme: Theme) => ({
  description: {
    fontSize: 16,
    color: theme.palette.text.primary,
    lineHeight: '33px',
    [theme.breakpoints.down(450)]: {
      lineHeight: '25px'
    }
  },
  respoDescription: {
    fontSize: 16,
    color: theme.palette.text.primary,
    lineHeight: '25px',
    height: 300,
    overflowY: 'hidden',
    [theme.breakpoints.down(450)]: {
      lineHeight: '25px'
    }
  },
  sactionCard: {
    width: '80%',
    minHeight: 460,
    borderRadius: '20px 20px 5px 5px',
    border: `4px solid ${theme.palette.secondary.main}`,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',

    alignItems: 'end',
    background: theme.palette.background.default,
    padding: '10px 20px',
    [theme.breakpoints.down(500)]: {
      marginTop: '10px'
    }
  },
  respoCard: {
    maxHeight: 500,
    width: '80%',
    borderRadius: '20px 20px 5px 5px',
    border: `4px solid ${theme.palette.secondary.main}`,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',

    alignItems: 'end',
    background: theme.palette.background.default,
    padding: '10px 20px',
    [theme.breakpoints.down(500)]: {
      marginTop: '10px'
    }
  },
  button: {
    border: 'none'
  },
  container: {
    display: 'grid',
    gridTemplateColumns: '210px auto',
    gridTemplateRows: '200px',
    alignItems: 'center',
    [theme.breakpoints.down(1024)]: {
      gridTemplateColumns: 'auto'
    }
  },
  backdrop: {
    ...imageContainer,
    position: 'relative',
    top: -10,
    left: -10,
    background: 'rgba(255, 255, 255, 0.2)',
    border: `1px solid ${theme.palette.common.white}`,
    boxShadow: '0px 2px 20px rgba(0, 0, 0, 0.2)'
  },
  image: {
    ...imageContainer,
    position: 'relative',
    zIndex: 1,
    filter: 'drop-shadow(0px 2px 20px rgba(0, 0, 0, 0.2))'
  },
  imageItem: {
    objectFit: 'cover',
    width: '100%',
    height: imageContainer.height,
    borderRadius: imageContainer.borderRadius
  },
  text: {
    color: theme.palette.info.main,
    fontSize: 20,
    marginBottom: 30,
    [theme.breakpoints.down(450)]: {
      marginBottom: '10px'
    }
  },
  textBox: {
    minHeight: 390,
    overflowY: 'hidden'
  },
  textContainer: {
    gridColumn: 2,
    gridRow: 1,
    background:
      'linear-gradient(90.1deg, rgba(255, 255, 255, 0.2) 0.1%, rgba(255, 255, 255, 0) 99.93%)',
    filter: 'drop-shadow(0px 2px 20px rgba(0, 0, 0, 0.2))',
    padding: '5px 0px 5px 10px',
    minHeight: 50,
    maxWidth: 550,
    alignItems: 'center',
    [theme.breakpoints.down(768)]: {
      maxWidth: 0
    },
    [theme.breakpoints.down(1024)]: {
      borderRadius: '5px 0px 0px 5px',
      maxWidth: 648,
      gridColumn: 1
    }
  }
}))
